<template>
  <v-card class="payout-confirm">
    <v-card-title>Pending Payment Resolution</v-card-title>

    <v-card-text>
      <p>You are about to resolve the following pending payment:</p>
      <v-simple-table
        class="mb-5"
      >
        <tbody>
          <tr>
            <td>User's email:</td>
            <td>{{ adminPendingPurchaseRequest.user.emailAddress }}</td>
          </tr>
          <tr>
            <td>Withdrawal Amount:</td>
            <td>{{ adminPendingPurchaseRequest.amountOwed | numberToMoney }}</td>
          </tr>
          <tr>
            <td>Date Requested:</td>
            <td>{{ adminPendingPurchaseRequest.executionTimestamp | timestampToDate }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>

    <v-card-actions
      class="mt-3"
    >
      <v-btn
          color="primary"
          :loading="loading"
          :disabled="loading"
          @click="confirmPayment"
      >
        <v-icon left>
          mdi-cash-check
        </v-icon>
        Confirm Payment
      </v-btn>
      <v-btn
          color="error"
          :loading="loading"
          :disabled="loading"
          @click="cancelPayment"
      >
        <v-icon left>
          mdi-cash-check
        </v-icon>
        Cancel Payment
      </v-btn>

      <v-btn
        color="error"
        :loading="loading"
        :disabled="loading"
        @click="cancel"
      >
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'PendingPaymentPaidConfirm',

    computed: {
      ...mapGetters([
        'adminPendingPurchaseRequest'
      ]),
    },

    data: () => ({
      loading: false
    }),

    methods: {
      ...mapActions([
        'markPendingPaymentAsPaid',
        'markPendingPaymentAsCanceled',
      ]),

      // Confirm purchase.
      confirmPayment: function () {
        this.loading = true

        this.markPendingPaymentAsPaid(this.adminPendingPurchaseRequest.id).then(() => {
          this.loading = false
          this.$emit('dialogClose')
        })
      },

      // Cancel purchase.
      cancelPayment: function () {
        this.loading = true

        this.markPendingPaymentAsCanceled(this.adminPendingPurchaseRequest.id).then(() => {
          this.loading = false
          this.$emit('dialogClose')
        })
      },

      // Cancel purchase.
      cancel: function () {
        this.$emit('dialogClose')
      }
    }
  }
</script>
